export type ReportView = 'grouped' | 'timeline';

const REPORT_VIEW_KEY = 'iorio.reportView';

export function getReportView(userId: string): ReportView {
  if (typeof window === 'undefined') return 'grouped';

  const saved =
    window.localStorage.getItem(reportViewKey(userId)) ??
    window.localStorage.getItem(REPORT_VIEW_KEY);
  return saved === 'timeline' ? 'timeline' : 'grouped';
}

export function setReportView(userId: string, view: ReportView) {
  window.localStorage.setItem(reportViewKey(userId), view);
}

function reportViewKey(userId: string): string {
  return `${REPORT_VIEW_KEY}.${userId}`;
}
